export const pxToRem = (dimensionInPixels) => `${dimensionInPixels / 16}rem`